module.exports = __webpack_public_path__ + "img/Innovation.55d1f055.png";